import React from 'react'
import PropTypes from 'prop-types'
import { Container, Divider } from 'components/UIElements'
import Subheader from '../../../../components/Subheader'
import VisitSchedulePreviewTable from './VisitSchedulePreviewTable'
import VisitScheduleAndDaySelector from './VisitScheduleAndDaySelector'
import VisitDaySelector from './VisitDaySelector'
import VisitCycleScheduleAndDaySelector from './VisitCycleScheduleAndDaySelector'

const VisitScheduleConfiguration = props => {
  const { selectedVisitScheduleId, setSelectedVisitScheduleId, isNewVisitVersion } = props

  return (
    <>
      <Container className='visit-schedule-configuration'>
        <Subheader subheaderText='Which visit schedule is this visit part of?' />
        <div className='flexed start-aligned'>
          {!isNewVisitVersion ? (
            <VisitScheduleAndDaySelector
              {...props}
              selectedVisitScheduleId={selectedVisitScheduleId}
              setSelectedVisitScheduleId={setSelectedVisitScheduleId}
            />
          ) : (
            <VisitCycleScheduleAndDaySelector
              {...props}
              selectedVisitScheduleId={selectedVisitScheduleId}
              setSelectedVisitScheduleId={setSelectedVisitScheduleId}
            />
          )}
          <Divider color='#f5f5f5' margin='0 20px' width='2px' isVertical />
          <VisitSchedulePreviewTable {...props} selectedVisitScheduleId={selectedVisitScheduleId} />
        </div>
      </Container>
      {isNewVisitVersion ? (
        <Container className='visit-schedule-configuration'>
          <Subheader subheaderText='When does this visit happen?' />
          <div className='visit-schedule-and-day-selector'>
            <VisitDaySelector {...props} />
          </div>
        </Container>
      ) : null}
    </>
  )
}

VisitScheduleConfiguration.propTypes = {
  selectedVisitScheduleId: PropTypes.string,
  setSelectedVisitScheduleId: PropTypes.func,
}

export default VisitScheduleConfiguration
